import { defineEnv } from "envin";
import * as z from "zod";

import { envConfig } from "@workspace/shared/constants";

import { sharedPreset } from "../utils/env";

import type { Preset } from "envin/types";

export const EmailProvider = {
  NODEMAILER: "nodemailer",
  RESEND: "resend",
  POSTMARK: "postmark",
  SENDGRID: "sendgrid",
  PLUNK: "plunk",
} as const;

export const preset = {
  id: "email-provider",
  server: {
    EMAIL_PROVIDER: z.enum(EmailProvider).optional(),
    RESEND_API_KEY: z.string().optional(),
    SENDGRID_API_KEY: z.string().optional(),
    PLUNK_API_KEY: z.string().optional(),
    POSTMARK_API_KEY: z.string().optional(),
    NODEMAILER_HOST: z.string().optional(),
    NODEMAILER_PORT: z.coerce.number().optional(),
    NODEMAILER_USER: z.string().optional(),
    NODEMAILER_PASSWORD: z.string().optional(),
  },
  extends: [sharedPreset],
} as const satisfies Preset;

export const env = defineEnv({
  ...envConfig,
  ...preset,
});

export type EmailProvider =
  (typeof EmailProvider)[keyof typeof EmailProvider];
